import React from "react";

import AmexIcon from "../../assets/images/AMEX.svg";
import MastercardIcon from "../../assets/images/Mastercard.svg";
import VisaIcon from "../../assets/images/VISA.svg";
import Condition from "../Conditional/Condition";
import "./PaymentMethodIcon.scss";

interface IPaymentMethodIconProps {
	paymentMethod: string;
}

const PaymentMethodIcon: React.FC<IPaymentMethodIconProps> = ({ paymentMethod }) => {
	const lowerMethod = paymentMethod.toLowerCase();

	return (
		<div className="PaymentMethodIcon">
			<Condition check={lowerMethod.includes("visa")}>
				<img src={VisaIcon} alt="Visa" className="PaymentMethodIcon__icon" />
			</Condition>

			<Condition check={lowerMethod.includes("master") && !lowerMethod.includes("visa")}>
				<img src={MastercardIcon} alt="Mastercard" className="PaymentMethodIcon__icon" />
			</Condition>

			<Condition
				check={
					lowerMethod.includes("amex") &&
					!lowerMethod.includes("visa") &&
					!lowerMethod.includes("master")
				}
			>
				<img src={AmexIcon} alt="Amex" className="PaymentMethodIcon__icon" />
			</Condition>

			<Condition
				check={
					!lowerMethod.includes("visa") &&
					!lowerMethod.includes("master") &&
					!lowerMethod.includes("amex")
				}
			>
				<span className="PaymentMethodIcon__text">{paymentMethod}</span>
			</Condition>
		</div>
	);
};

export default PaymentMethodIcon;
